
import React from 'react';
import {Overlay} from "../../components/modal";
import {
  DIALOG_STYLE, render_header, render_amt_input,
  dump_input, dump_pair, ERRORS, parse_amt, mult_of_1000
} from "./common";
import {sprintf} from "sprintf-js";
import {TextLoading} from "../../funcs/utils";

const render_firm_name = component => {

  const firm_style = {};
  const last_style = {};
  if (component.state.blank_firm_name) {
    firm_style.border = "2px solid red";
  }
  if (component.state.blank_last_name) {
    last_style.border = "2px solid red";
  }
  return (
    <div>
      { dump_pair(
        (<div style={{flex: "1"}}>
          Firm Name:
        </div>),
        (<div style={{display: "flex"}}>
          <div align={"center"} style={{width: "1.5rem"}}/>
          <div style={{flex: "1"}}>
            { dump_input(component, "firm_name", firm_style)}
          </div>
        </div>))}
      <div style={{height: "1rem"}}/>
      { dump_pair(
        (<div style={{flex: "1"}}>
          Last Name:
        </div>),
        (<div style={{display: "flex"}}>
          <div align={"center"} style={{width: "1.5rem"}}/>
          <div style={{flex: "1"}}>
            { dump_input(component, "last_name", last_style)}
          </div>
        </div>))}
    </div>
  )
}

const render_button = (component, bg_color, cusip) => {
  const style = {
    background: sprintf("rgba(%d, %d, %d", bg_color.r, bg_color.g, bg_color.b),
    width: "10rem",
    padding: "0.5rem 0"
  }

  const on_click = () => {
    const new_state = {};
    let blank = false;
    if (component.state.firm_name === "") {
      new_state.blank_firm_name = true;
      blank = true;
    }
    if (component.state.last_name === "") {
      new_state.blank_last_name = true;
      blank = true;
    }
    if (component.state.purchase_amt === "") {
      new_state.blank_amt = true;
      blank = true;
    }
    if (blank) {
      component.setState(new_state);
      return;
    }

    const amt = parse_amt(component.state.purchase_amt);
    if (amt < 1000.) {
      component.setState({
        dialog_error: ERRORS.TOO_SMALL,
      })
    } else if (!mult_of_1000(amt)) {
      component.setState({
        dialog_error: ERRORS.MULTIPLE_1000,
      });
    }
    component.onPurchaseNoLoginClick(cusip.CUSIP);
  }
  const is_purchasing = component.state.is_purchasing;

  return (
    <button
      style={style}
      onClick={on_click}>
      <TextLoading label={"Purchase"} loading={is_purchasing}/>
    </button>
  )
}

const render_footer = (component, cusip) => {
  const client = component.props.client;
  const button_bg = client.color.sign_on_button;
  const container_style = {
    display: "flex",
    marginTop: "2rem",
    justifyContent: "center",
  }
  return (
    <div style={container_style}>
      { render_button(component, button_bg, cusip)}
    </div>);
}

const PurchaseNoLoginModal = props => {

  const item = props.item;
  const component = props.component;
  console.log("PurchaseNoLoginModal", component.state.is_purchasing);
  return (
    <Overlay>
      <div style={DIALOG_STYLE}>
        { render_header(item, component) }
        <div style={{height: "2rem"}}/>
        { render_amt_input(component) }
       <div style={{height: "1rem"}}/>
        { render_firm_name(component) }
        <div style={{height: "1rem"}}/>
        { render_footer(component, item) }
      </div>
    </Overlay>
  )
}

export { PurchaseNoLoginModal };
